import { Component } from '@angular/core';
import {
  EmperorCardHeaderColor,
  EmperorDialogConfig,
  EmperorThemeColor,
  EmperorUIButtonTypes,
} from '@boldpenguin/emperor-presentational';
import { Action, Store } from '@ngrx/store';

@Component({
  selector: 'app-user-activation-change-dialog',
  templateUrl: './user-activation-change-dialog.component.html',
  styleUrls: ['./user-activation-change-dialog.component.scss'],
})
export class UserActivationChangeDialogComponent {
  readonly emperorUIButtonTypes = EmperorUIButtonTypes;
  readonly EmperorThemeColor = EmperorThemeColor;
  readonly EmperorCardHeaderColor = EmperorCardHeaderColor;
  data: {
    activate: boolean;
    confirmAction: Action;
    hasInvitationBeenSent: boolean;
  };

  constructor(
    config: EmperorDialogConfig,
    private store: Store,
  ) {
    this.data = config.data;
  }

  confirm(): void {
    this.store.dispatch(this.data.confirmAction);
  }
}
